import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loading-overlay",
  templateUrl: "./loading-overlay.component.html",
  styleUrls: ["./loading-overlay.component.scss"],
  standalone: false,
})
export class LoadingOverlayComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
